import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import {
  AppNotifications,
  BlogStatus,
  FORM_MODE,
  RootState,
  NewsInputModel,
  TCb,
  UploadedImageModel,
  LanguageOutputModel,
  NewsOutputModel,
} from "../../../../../models";
import { NewsService } from "../../../../../services";
import { NotificationActions, AllLanguageListActions } from "../../../../../store/actions";
import NewsFormPresenter from "./NewsForm.presenter";
import { C_Props, C_States, MapDispatchToProps, MapStateToProps, MergedProps } from "./NewsForm.type";
import { v4 as uuidv4 } from "uuid";
import { ImageUtil, loadCallback } from "../../../../../utils";
import { withRouter } from "react-router-dom";

class NewsFormContainer extends Component<MergedProps, C_States> {
  constructor(props) {
    super(props);

    this.state = {
      mode: FORM_MODE.CREATE,
      loading: false,
      initData: null,

      newsStatus: {
        status: false,
        timePublication: null,
        isPublish: false,
      },

      newsContent: {},
      newNewsContent: null,

      newsPictures: [],
      languageData: this.props.all_language_list.data,
      activeLanguageId: this.props.all_language_list.data.find((e: LanguageOutputModel) => e.isPrimary)?.id,
      filter: {
        code: "",
      },
      bannerImage: "",
      newsDetail: null,
    };
  }

  onChangeLanguage = (languageId: string) => {
    this.setState({
      activeLanguageId: languageId,
    });
  };

  onUploadBanner = (data: UploadedImageModel) => {
    const formData = new FormData();
    formData.append("image", data.file);
    NewsService.uploadImageNewsPage(formData)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.setState({
            newsPictures: [{ id: uuidv4(), src: ImageUtil.buildNewImgSrc(res.data.data)!, alt: data.alt || "" }],
          });
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Upload image failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Upload image failed" });
      });
  };

  onRemoveBanner = (fileId: string) => {
    const banners = this.state.newsPictures.filter((p) => p.id !== fileId);
    this.setState({
      newsPictures: banners,
    });
  };

  onChangeNewsStatus = (status: boolean) => {
    this.setState((prevState) => {
      return {
        newsStatus: {
          ...prevState.newsStatus,
          status,
        },
      };
    });
  };

  onChangeShowPublishTime = (isPublish: boolean) => {
    this.setState((prevState) => {
      return {
        newsStatus: {
          ...prevState.newsStatus,
          isPublish,
        },
      };
    });
  };

  onChangeTimePublication = (date: string | null) => {
    this.setState((prevState) => {
      return {
        newsStatus: {
          ...prevState.newsStatus,
          timePublication: date,
        },
      };
    });
  };

  onUploadContentImgHandler() {
    const self = this as any;
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input.files![0];
      const formData = new FormData();

      formData.append("image", file);
      // Save current cursor state
      const range = self.quill.getSelection(true);
      // Insert temporary loading placeholder image
      // quill.insertEmbed(range.index, "image", `${window.location.origin}/images/loaders/placeholder.gif`);

      // Move cursor to right side of image (easier to continue typing)
      self.quill.setSelection(range.index + 1, 1);

      const res = await NewsService.uploadImageNewsPage(formData);

      // Remove placeholder image
      // quill.deleteText(range.index, 1);

      if (res && res.status === 201) {
        self.quill.insertEmbed(range.index, "image", ImageUtil.buildNewImgSrc(res.data.data));
      }
    };
  }

  onChangeNewsContent = (val: any, langId: string) => {
    this.setState((prev) => {
      return {
        newsContent: {
          ...prev.newsContent,
          [langId]: val,
        },
      };
    });
  };

  onSubmit = (val: any) => {
    if (!this.state.newsPictures.length) {
      this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Please upload an image" });
      return;
    }

    if (!this.state.newsContent) {
      this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Please input content" });
      return;
    }

    const banner = this.state.newsPictures[0];

    let data: NewsInputModel[] = [];
    console.log(val);

    this.state.languageData.forEach((lang) => {
      if (val[`title${lang.id}`]) {
        let dataObj: any = {
          title: val[`title${lang.id}`],
          bannerImage: ImageUtil.convertImgServerSrc(banner.src, "blog"),
          status: this.state.newsStatus.status ? BlogStatus.PUBLISH : BlogStatus.UNPUBLISH,
          publishDate: this.state.newsStatus.timePublication,
          isPublish: this.state.newsStatus.isPublish,
          description: this.state.newsContent[lang.id],
          shortDescription: val[`shortDescription${lang.id}`],
          categoryId: val[`categoryId${lang.id}`],
          languageId: lang.id,
        };
        // dataObj = _.pickBy(dataObj, (v) => !_.isUndefined(v));
        const found = this.state.initData?.find((i) => i.languageId === lang.id) || false;
        this.state.mode !== FORM_MODE.CREATE &&
          found &&
          Object.assign(dataObj, {
            id: this.state.initData?.find((i) => i.languageId === lang.id)?.id,
          });
        data.push(dataObj);
      }
    });

    if (this.state.mode === FORM_MODE.CREATE) {
      this.onCreateNews(data);
    } else {
      this.onUpdateNews(data);
    }
  };

  onLoadAllNewsDetail = (newsPageCode: string, cb?: TCb) => {
    this.setState({ loading: true, initData: null }, () => {
      NewsService.getNewsPage(newsPageCode)
        .then((res) => {
          if (res && (res.status === 200 || res.status === 201)) {
            const data: NewsOutputModel[] = res.data.data;

            data.forEach((item) => {
              const banner = item.bannerImage
                ? {
                    id: item.id,
                    src: ImageUtil.buildNewImgSrc(item.bannerImage)!,
                    alt: item.bannerImage || "",
                  }
                : undefined;

              this.setState({
                newsPictures: banner ? [banner] : [],
                newsStatus: {
                  status: item.status === BlogStatus.PUBLISH,
                  timePublication: item.publishDate,
                  isPublish: item.isPublish,
                },
                // newNewsContent: item.description,
              });
            });

            this.setState(
              {
                mode: FORM_MODE.EDIT,
                newsDetail: data,
                initData: data,
                loading: false,
                newsContent: data.reduce((res, item) => {
                  return {
                    ...res,
                    [item.languageId]: item.description,
                  };
                }, {}),
              },
              () => {
                loadCallback(cb?.success);
              },
            );
          } else {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Load data failed",
            });
            this.props.history.goBack();
          }
        })
        .catch((err) => {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Load data failed",
          });
        });
    });
  };

  onCreateNews = (data) => {
    NewsService.createNewsPage(data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Create post success",
          });
          loadCallback(this.props.onComplete_Create);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create post failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create post failed" });
      });
  };

  onUpdateNews = (data) => {
    NewsService.updateNewsPage(this.props.newsPageCode!, data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Update post success",
          });
          loadCallback(this.props.onComplete_Update);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Update post failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Update post failed" });
      });
  };

  componentDidMount = () => {
    if (this.props.newsPageCode) {
      // this.onLoadNewsDetail(this.props.newsPageCode);
      this.onLoadAllNewsDetail(this.props.newsPageCode);
    }
  };

  render() {
    return (
      <NewsFormPresenter
        {...this.props}
        {...this.state}
        onUploadBanner={this.onUploadBanner}
        onRemoveBanner={this.onRemoveBanner}
        onChangeLanguage={this.onChangeLanguage}
        onChangeNewsStatus={this.onChangeNewsStatus}
        onChangeTimePublication={this.onChangeTimePublication}
        onChangeShowPublishTime={this.onChangeShowPublishTime}
        onUploadContentImgHandler={this.onUploadContentImgHandler}
        onChangeNewsContent={this.onChangeNewsContent}
        onSubmit={this.onSubmit}
      />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,
    }),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions, AllLanguageListActions), dispatch),
    }),
  )(NewsFormContainer),
);
